export enum DocumentEditorActionsType {
  UPSERT_VALUE = 'upsert_value',
  ACTIVE_ACTION = 'active_action',
  DEACTIVATE_ACTION = 'deactivate_action',
  APP_VALUE = 'app_value',
  ALIGN_CATEGORY = 'align_category',
  UPSERT_DATA_RETENTION_AND_DELETION = 'upsert_data_retention_and_deletion',

  // Nuovi trigger trattamento
  ALIGN_RESPONSIBLE_ME = 'align_responsible_me',
  ALIGN_RESPONSIBLE = 'align_responsible',
  ALIGN_REPRESENTATIVE_OF_RESPONSIBLE = 'align_representative_of_responsible',
  ALIGN_HOLDER = 'align_holder',
  ALIGN_REPRESENTATIVE_OF_HOLDER = 'align_representative_of_holder',
  ALIGN_SUB_RESPONSIBLE = 'align_sub_responsible',
  ENABLE_LIA = 'enable_lia',

  // Usato nell'initialization
  VALUE = 'value',
  INITIALIZATION = 'initialization',


  // preliminaryRisk-from-treatmentDataInterested
  PRELIMINARY_RISK_FROM_TREATMENT_DATA_INTERESTED = 'preliminaryRisk-from-treatmentDataInterested',
  PRELIMINARY_RISK_FROM_CHECKBOX = 'preliminaryRisk-from-checkbox',

}
